const isCustomerRole = (role) => {
  if (!role && role !== 0) return false;

  const value =
    typeof role === 'string'
      ? role
      : role?.name || role?.role || role?.role_name || role?.slug || role?.code || String(role);

  const normalized = value?.toString().toLowerCase();
  if (!normalized) return false;

  return normalized === 'customer' || normalized === 'cliente';
};

export default isCustomerRole;
